<template>
  <div :class="{'fragment': isPartnerArticlePage && url}">
    <div
      v-if="preRender && !isLocal"
      :data-ssi="ssi || false"
      :data-ssr="ssr || false"
      :data-url="`${url}${queryString}` || ''"
    />

    <div v-else>
      <zg-transition-block>
        <zg-loader
          v-if="!html"
          key="loader"
          linear
        />

        <div
          v-else
          key="html"
          v-append="html"
        />
      </zg-transition-block>
    </div>
  </div>
</template>

<script>
import { ContentType } from '@ocp-zmarta/content-lib'
import { isLocal } from '../utils/is-local'

export default {
  name: 'FragmentComponent',
  components: {
    ZgLoader: () => import('@zc/components/ZgLoader/ZgLoader'),
    ZgTransitionBlock: () => import('@zc/components/ZgTransitionBlock/ZgTransitionBlock')
  },
  inheritAttrs: false,
  props: {
    ssi: {
      type: Boolean,
      required: false
    },
    ssr: {
      type: Boolean,
      required: false,
      default: true
    },
    url: {
      type: String,
      required: true
    },
    site: {
      type: String,
      required: true
    },
    pageType: {
      type: String,
      required: false,
      default: ContentType.ProductLandingPage
    },
    preRender: {
      type: Boolean,
      required: false,
      default: true
    },
    fetchFragment: {
      type: Boolean,
      required: false,
      default: false
    },
    customQuery: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data: () => ({
    html: null,
    isLoaded: false
  }),
  computed: {
    isLocal () {
      return isLocal()
    },
    queryString () {
      return Object.entries(this.customQuery)
        .map(([key, val]) => `&${key}=${val}`)
        .join('')
    },
    isPartnerArticlePage () {
      return [ContentType.Article, ContentType.PartnerPage].includes(this.pageType)
    }
  },
  watch: {
    fetchFragment () {
      if (this.fetchFragment && !this.isLoaded) this.setHtml()
    }
  },
  mounted () {
    if (this.fetchFragment || this.isLocal) this.setHtml()
  },
  methods: {
    async setHtml () {
      try {
        if (this.html) return

        const response = await fetch(this.url, {
          method: 'GET',
          headers: {
            brand: 'zmarta',
            country: this.site?.split('.')?.pop()
          }
        })

        this.html = await response?.text()

        this.isLoaded = true
        this.$emit('loaded')
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fragment {
  background-color: color(beige);
  border-radius: rhythm(medium);
  padding: rhythm(base);
}
</style>
